import dynamic from 'next/dynamic'

import { Container, Filters, If, SectionHeader } from '@/components'

import { FilterCards, Solution } from './components'

import { useSolutions } from './useSolutions'

import styles from './Solutions.module.scss'

const ServicesModal = dynamic(() =>
  import('@/components/ServicesModal/ServicesModal').then(
    (mod) => mod.ServicesModal
  )
)

export const Solutions = ({ variant = 'postpaid', title, subtitle }) => {
  const {
    filters,
    activeFilterIndex,
    visibleDetailsModal,
    visibleService,
    isMobile,
    onSelectFilter,
    setVisibleDetailsModal
  } = useSolutions({
    variant
  })

  return (
    <section id="solucoes-empresa" className={styles.solutions}>
      <Container>
        <SectionHeader
          tagText="Soluções"
          tagBackground="white"
          title={title}
          subtitle={subtitle}
        />

        <div className={styles.solutions__wrapper}>
          <If
            condition={isMobile}
            renderIf={
              <Filters
                variant="tertiary"
                section="solutions"
                filters={filters}
                activeFilterIndex={activeFilterIndex}
                setActiveFilterIndex={onSelectFilter}
              />
            }
            renderElse={
              <FilterCards
                filters={filters}
                activeFilterIndex={activeFilterIndex}
                onSelectFilter={onSelectFilter}
              />
            }
          />

          <Solution
            visibleService={visibleService}
            onClickAction={(type) => setVisibleDetailsModal(type)}
          />
        </div>

        {visibleDetailsModal && (
          <ServicesModal
            isVisible={true}
            type={visibleDetailsModal}
            closeModal={() => setVisibleDetailsModal(null)}
          />
        )}
      </Container>
    </section>
  )
}
